<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'CurrencyComponent.vue'
}
</script>

<style scoped></style>
